import type { Ref } from 'react'

type TextFieldProps = {
    label: string
    value: string
    onChange: (value: string) => void
    type?: 'text' | 'password'
    placeholder?: string
    autoComplete?: string
    centered?: boolean
    error?: string | null
    inputRef?: Ref<HTMLInputElement>
}

export const TextField = ({
    label,
    value,
    onChange,
    type = 'text',
    placeholder,
    autoComplete,
    centered = false,
    error,
    inputRef,
}: TextFieldProps) => {
    return (
        <label className="flex flex-col gap-1.5">
            <span className="text-account-primary text-sm font-semibold">{label}</span>
            <input
                ref={inputRef}
                type={type}
                value={value}
                placeholder={placeholder}
                autoComplete={autoComplete}
                aria-invalid={!!error}
                onChange={(event) => onChange(event.target.value)}
                className={[
                    'bg-account-surface text-account-strong focus:border-account-accent focus:ring-account-accent w-full rounded-lg border p-2.5 outline-none transition focus:ring-1',
                    error
                        ? 'border-account-error-border focus:border-account-error focus:ring-account-error'
                        : 'border-account-border',
                    centered ? 'text-center font-mono text-lg tracking-[0.35em]' : '',
                ].join(' ')}
            />
            {error && <span className="text-account-error text-xs">{error}</span>}
        </label>
    )
}
